import { Switch as SwitchNew } from "@hortis/ui/switch";
import CoreSwitch from "@mui/material/Switch";
import { useController } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import { applyMui } from "../../utils/apply-mui";
import { withTestId } from "../../utils/with-test-id";

export const Switch = applyMui(withTestId, CoreSwitch);

interface FormFieldProps {
  name: string;
  label: string;
  initialValue?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  testId?: string;
  className?: string;
}
// best we can do because of limitations of react hook form
// and generic string 'literals'
type FormValues = { [Key in string]: boolean };

export const SwitchFormField = withTestId<FormFieldProps>(
  ({ name, label, initialValue, testId, className, ...rest }) => {
    const {
      field: { value, onChange },
    } = useController<FormValues>({
      name,
      defaultValue: initialValue,
    });

    return (
      <label
        className={twMerge(
          "flex items-center justify-end gap-2 text-sm font-medium text-grey-500",
          className,
        )}
      >
        {label}
        <SwitchNew
          data-cy={testId}
          onCheckedChange={(checked) => {
            onChange(checked);
          }}
          checked={value}
          {...rest}
        />
      </label>
    );
  },
);
